import Vue from "vue";
import Vuex from "vuex";
import { RootState } from "./types";
import createPersistedState from "vuex-persistedstate";

import auth from "@/modules/auth/vuex/index";
import automation from "@/modules/automation/vuex/index";
import applicant from "@/modules/applicants/vuex/index";
import integration from "@/modules/integration/vuex/index";
import settings from "@/modules/settings/vuex/index";
import activation from "@/modules/activation/vuex/index";
import webhooks from "@/modules/webhooks/vuex/index";
import team from "@/modules/team/vuex/index";
import subscriptions from "@/modules/subscriptions/vuex/index";
import customization from "@/modules/customization/vuex/index";
import business from "@/modules/businesses/vuex/index";

//Encrypt Localstorage
import SecureLS from "secure-ls";
const ls = new SecureLS({});
Vue.use(Vuex);

//Store initial store, for resets
const initialState: RootState = {
  auth: auth.state,
  activation: activation.state,
  applicant: applicant.state,
  integration: integration.state,
  settings: settings.state,
  webhooks: webhooks.state,
  team: team.state,
  automation: automation.state,
  subscriptions: subscriptions.state,
  customization: customization.state,
  business: business.state,
};

//Persist User data state in localstorage
const authState = createPersistedState({
  paths: ["auth"],
  storage: {
    getItem: (key) => ls.get(key),
    setItem: (key, value) => ls.set(key, value),
    removeItem: (key) => ls.remove(key),
  },
});

export default new Vuex.Store({
  state: {},
  mutations: {
    //Loop through modules and reset each
    reset(state: RootState) {
      Object.keys(state).forEach((key) => {
        Object.assign(state[key], initialState[key]);
      });
    },
  },
  actions: {},
  modules: {
    auth,
    applicant,
    integration,
    activation,
    settings,
    webhooks,
    automation,
    team,
    subscriptions,
    customization,
    business,
  },
  plugins: [authState],
});
